export function CheckboxListController($q, localeService) {
    'ngInject'
    /* jshint validthis:true */
    const vm = this;
    vm.$onInit = onInit;
    vm.class;
    vm.items;
    vm.selected;
    vm.readOnly;
    vm.valueField;
    vm.collectionName;
    vm.checkboxes;

    vm.selectItem = selectItem;
    vm.checkboxListChange;
    vm.init = onInit;


    function onInit() {
        vm.listNum = CheckboxListController.listNum++;
        let newKey = -1;
        $q.all(vm.items.map(function (item, i) {
            const selectedItem = Object.keys(vm.selected).reduce(function (res, key) {
                return res || (vm.selected[key][vm.valueField] === item.Value ? vm.selected[key] : null);
            }, null);
            let description;
            if (item.SupplementalText[0] === "|") {
                // Translate the description using the locale service.
                description = localeService.retrieveCurrentLocaleTranslations()
                    .then(function (translations) {
                        return translations[item.SupplementalText.substring(1, item.SupplementalText.length)];
                    });
            } else {
                description = $q.when(item.SupplementalText);
            }
            return description.then(function (description) {
                return {
                    text: item.Text,
                    name: 'apexcbl_' + vm.listNum + '_' + i,
                    value: item.Value,
                    description: description,
                    id: selectedItem && (selectedItem.Id > 0 || selectedItem.IsNew) ? selectedItem.Key : newKey--,
                    checked: selectedItem && (selectedItem.Id > 0 || selectedItem.IsNew)
                        ? !selectedItem.IsDeleted : false,
                    isNew: selectedItem && (selectedItem.Id > 0 || selectedItem.IsNew) ? selectedItem.IsNew : false,
                    isDeleted: selectedItem && (selectedItem.Id > 0 || selectedItem.IsNew)
                        ? selectedItem.IsDeleted : false,
                    canBeNew: selectedItem && (selectedItem.Id > 0 || selectedItem.IsNew) ? selectedItem.IsNew : true,
                    canDelete: !!selectedItem && (selectedItem.Id > 0 || selectedItem.IsNew)
                }
            });
        }))
            .then(function (checkboxes) {
                vm.checkboxes = checkboxes;

                if (vm.checkboxListChange && vm.checkboxes) {
                    vm.checkboxListChange({ data: vm.checkboxes });
                }
            });
    }

    function selectItem(value) {
        if (value.canBeNew) {
            value.isNew = value.checked;
        } else if (value.canDelete) {
            value.isDeleted = !value.checked;

        }
        if (value.checked) {
            vm.selected[value.id] = {
                Key: value.id
            };
            vm.selected[value.id][vm.valueField] = value.Value;
        } else if (vm.selected[value.id]) {
            delete vm.selected[value.id];
        }
        if (vm.checkboxListChange && vm.checkboxes) {
            vm.checkboxListChange({ data: vm.checkboxes, item: value });
        }
    }
}

CheckboxListController.listNum = 0;
